import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Division } from '../../models/division.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class DivisionService {

  private baseUrl = HttpClientService.BASE_MS_COMMON + '/divisions';

  divisions: Division[];
  divisionEditing: Division;
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(division_id) {
    return this.h.get(this.baseUrl + '/' + division_id);
  }

  getAll() {
    return this.h.get(this.baseUrl + '/')
      .map(res => {
        this.divisions = res;
        return res;
      });
  }

  delete(record) {
    return this.h.delete(this.baseUrl + '/' + record.id)
      .map(() => {
        this.divisions.splice(this.divisions.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Division deleted'});
      });
  }

  post(newData) {
    return this.h.post(this.baseUrl + '/', newData)
      .map(res => {
        newData.id = res.id;
        this.divisions.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put(this.baseUrl + '/', newData)
      .map(() => {
        Object.assign(this.divisionEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/DivisionDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/division/division.service.ts